module.exports = __webpack_public_path__ + "static/media/getapp-ios.23ed0759.png";